module.exports = __webpack_public_path__ + "img/success-green.204f2ee9.svg";